




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'number-field' })
export default class NumberFieldComponent extends Vue {
  @Prop() public value!: string;
  @Prop() public name!: string;

  public get innerValue() { return this.value; }
  public set innerValue(val: string) {
    this.$emit('input', parseFloat(val));
  }
}
